import { FC, useContext } from 'react';

import { LocalizationContext } from 'localization';

import s from './RightBlock.module.scss';

export const ImageTooltip: FC = () => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s.tooltip}>
      <div className={s.block}>
        <span className={s.text}>{t('application.image.minRes')}</span>
        <span className={s.value}>312х176</span>
      </div>
      <div className={s.block}>
        <span className={s.text}>{t('goods.edit.photo.optimalRes')}</span>
        <span className={s.value}>624х352</span>
      </div>
      <div className={s.block}>
        <span className={s.text}>{t('application.image.sides')}</span>
        <span className={s.value}>16:9</span>
      </div>
      <div className={s.block}>
        <span className={s.text}>{t('application.image.maxSize')}</span>
        <span className={s.value}>640 kb</span>
      </div>
      <div className={s.block}>
        <span className={s.text}>{t('application.image.format')}</span>
        <span className={s.value}>.jpg, .png</span>
      </div>
    </div>
  );
};
